import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import { walletServices } from "../services/WalletServices";

const AdminWallets = () => {
  const [wallets, setWallets] = useState([]);
  const [walletAddress, setWalletAddress] = useState("");
  const [networkType, setNetworkType] = useState("USDT_ERC20");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchWallets();
  }, []);

  const fetchWallets = async () => {
    try {
      const response = await walletServices.fetchWalletDetails();
      if (response.status === 200 && response.data.success) {
        setWallets(response.data.data);
      } else {
        toast.error(response?.data?.message || "Failed to fetch wallet details.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch wallet details.");
    }
  };

  const handleAddOrEdit = async () => {
    const payload = {
      wallet_address: walletAddress,
      network_type: networkType,
    };

    try {
      if (isEditing && selectedWallet) {
        const response = await walletServices.updateWalletAddress(selectedWallet._id, payload);
        if (response.status === 200) {
          toast.success("Wallet updated successfully");
        } else {
          toast.error(response.data?.message || "Failed to update wallet");
        }
      } else {
        const response = await walletServices.addWalletAddress(payload);
        if (response.status === 201 || response.status === 200) {
          toast.success("Wallet added successfully");
        } else {
          toast.error(response.data?.message || "Failed to add wallet");
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }

    setShowModal(false);
    setWalletAddress("");
    setNetworkType("USDT_ERC20");
    fetchWallets();
  };

  const handleDelete = async (id) => {
    try {
      const response = await walletServices.deleteWalletAddress(id);
      if (response.status === 200) {
        toast.success("Wallet deleted successfully");
        fetchWallets();
      } else {
        toast.error(response.data?.message || "Failed to delete wallet");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const handleStatusToggle = async (wallet) => {
    try {
      const response = await walletServices.updateWalletAddress(wallet._id, {
        status: !wallet.status,
      });
      if (response.status === 200) {
        toast.success("Status updated successfully");
        fetchWallets();
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const openModal = (wallet = null) => {
    setShowModal(true);
    if (wallet) {
      setIsEditing(true);
      setSelectedWallet(wallet);
      setWalletAddress(wallet.wallet_address);
      setNetworkType(wallet.network_type);
    } else {
      setIsEditing(false);
      setSelectedWallet(null);
      setWalletAddress("");
      setNetworkType("USDT_ERC20");
    }
  };

  return (
    <div className="container">
      <h1>Admin Wallets</h1>
      <Button onClick={() => openModal()}>Add Wallet</Button>
      <table className="table mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Wallet Address</th>
            <th>Network Type</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {wallets.map((wallet, index) => (
            <tr key={wallet._id}>
              <td>{index + 1}</td>
              <td>{wallet.wallet_address}</td>
              <td>{wallet.network_type}</td>
              <td>
                <input
                  type="checkbox"
                  checked={wallet.status}
                  onChange={() => handleStatusToggle(wallet)}
                />
              </td>
              <td>
                <Button variant="secondary" onClick={() => openModal(wallet)} className="me-2">
                  <i className="fa fa-pencil"></i>
                </Button>
                <Button variant="danger" onClick={() => handleDelete(wallet._id)}>
                  <i className="fa fa-trash"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Edit Wallet" : "Add Wallet"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label htmlFor="wallet_address" className="form-label">
                Wallet Address
              </label>
              <input
                type="text"
                className="form-control"
                id="wallet_address"
                value={walletAddress}
                onChange={(e) => setWalletAddress(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="network_type" className="form-label">
                Network Type
              </label>
              <select
                className="form-control"
                id="network_type"
                value={networkType}
                onChange={(e) => setNetworkType(e.target.value)}
              >
                <option value="USDT_ERC20">USDT_ERC20</option>
                <option value="USDT_BEP20">USDT_BEP20</option>
                <option value="USDT_TRC20">USDT_TRC20</option>
                <option value="ETH">ETH</option>
                <option value="BTC">BTC</option>
              </select>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddOrEdit}>
            {isEditing ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminWallets;
